var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75H30C36.5625 3.75 39.375 7.5 39.375 13.125V31.875C39.375 37.5 36.5625 41.25 30 41.25H15C8.4375 41.25 5.625 37.5 5.625 31.875V13.125C5.625 7.5 8.4375 3.75 15 3.75ZM20.4938 29.0437C21.45 32.1 24.8062 33.6937 25.7437 33.6937C26.6625 33.675 29.9812 32.1187 30.975 29.0437C31.5938 27.1125 30.8625 24.7313 28.8563 24.075C27.7875 23.7375 26.475 24.0187 25.7437 25.05C25.05 23.9812 23.6812 23.7375 22.6312 24.075C20.6062 24.7313 19.8938 27.1125 20.4938 29.0437ZM10.3125 17.3438H14.0625C16.9125 17.3438 19.2188 15.0375 19.2188 12.1875V8.4375C19.2188 7.66875 18.5812 7.03125 17.8125 7.03125C17.0438 7.03125 16.4062 7.66875 16.4062 8.4375V12.1875C16.4062 13.4812 15.3563 14.5312 14.0625 14.5312H10.3125C9.54375 14.5312 8.90625 15.1687 8.90625 15.9375C8.90625 16.7063 9.54375 17.3438 10.3125 17.3438Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityBlack);
export default __webpack_public_path__ + "static/media/communityBlack.36801d9966492ac7ec0a621b8fde5ec9.svg";
export { ForwardRef as ReactComponent };